import React, { useEffect, useState } from 'react'
import Account from './details'
import { useAuth } from '../../../providers/auth_provider'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import EditFrequency from './edit_frequency'
import { Helmet } from 'react-helmet'
import Player from '../modals/player'
import MusicPlayer from '../../music/modal/player';

export default function ViewFrequencies() {
    const [frequencyData, setfrequencyData] = useState(null);
    const { token } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const frequency_id = location?.state?.frequency_id;
    const [uploadedMusic, setUploadedMusic] = useState([]);


    const fetchFrequencyData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/frequency/${frequency_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            })
            if (response.status === 200) {
                setfrequencyData(response.data.frequency)
            }
        }
        catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        if (!frequency_id) {
            navigate('/frequency/view');
        } else {
            fetchFrequencyData();
        }
    }, [frequency_id]);


    const fetchUploadedMusic = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/music/all`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setUploadedMusic(response.data.music);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchUploadedMusic();
    }, []);

    return (
        <>
            <Helmet>
                <title className='text-capitalize'>{frequencyData?.title}</title>
            </Helmet>
            <div className="row gy-6 gy-md-0">
                {/* User Sidebar */}
                <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0">
                    {/* Player Card */}
                    <div className="user-avatar-section rounded">
                        <Player frequencyData={frequencyData} source={frequencyData?.frequency_audio} />
                        <MusicPlayer frequencyData={frequencyData} source={uploadedMusic.length > 0 ? uploadedMusic[0].music_audio : ''} />
                    </div>
                </div>
                <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                    <Account frequencyData={frequencyData} />
                </div>
            </div>
            {/* Edit User Modal */}
            <EditFrequency fetchFrequencyData={fetchFrequencyData} frequencyData={frequencyData} />
            {/*/ Edit User Modal */}
        </>
    )
}
